import { useState, useEffect } from 'react'
import { Navigation } from './components/navigation'
import { Header } from './components/header'
import { About } from './components/about'
import { Training } from './components/training'
import { Calendar } from './components/calendar'
import { Gallery } from './components/gallery'
import { Testimonials } from './components/testimonials'
import { Contact } from './components/contact'
import { ReactHelmet } from './utils/reactHelmet'
import JsonData from './data/data.json'
import SmoothScroll from 'smooth-scroll'

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
})

const App = () => {
  const [landingPageData, setLandingPageData] = useState({})
  useEffect(() => {
    setLandingPageData(JsonData)
  }, [])

  return (
    <div>
      <ReactHelmet />
      <Navigation />
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      {/* <Team data={landingPageData.Team} /> */}
      <Training data={landingPageData.Training} />
      <Gallery />
      <Calendar />
      <Testimonials data={landingPageData.Testimonials} />
      <Contact data={landingPageData.Contact} />
    </div>
  )
}

export default App
